import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="d-sm-flex justify-content-center justify-content-sm-between">
          <span className="text-muted text-center mx-auto d-block d-sm-inline-block">
            Copyright © 2021{" "}
            <a
              href="https://dashboard.diaq.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              DigitalAirProduct
            </a>
            . All rights reserved.
          </span>
        </div>
      </footer>
    );
  }
}

export default Footer;
